/**
 * メインページを開く
 */
export const openMain = (selector, timeoutMsec = 300) => {
    const mainEl = document.querySelector('.main');
    if (mainEl === null) {
        return;
    }
    // 終了
    setTimeout(() => {
        mainEl.classList.remove('enter');
        mainEl.classList.remove('enter-active');
    }, timeoutMsec);
    // アニメーション開始
    mainEl.classList.add('enter-active');
};
